import React, { createElement, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../components/button.jsx";
import Loading from "../components/loading.jsx";
import post from "../functions/post.js";

const EditQuiz = ({info, allQuestions, buttonOne, onSuccess, onFail, edit=false}) => {

    const location = useLocation();
    const navigate = useNavigate();

    const [ error, setError ] = useState("");
    const [ loading, setLoading ] = useState(false);
    const [ answers, setAnswers ] = useState([]);
    const [ chosenNoun, setChosenNoun ] = useState({
        noun: "",
        kasus: ""
    });

    const createAnswers = (s, a) => {

        const punctuation = /^[.,:;?!]+$/;
        let finalAnswers = [...a];
        const remainingAnswers = s.filter(w => !a.includes(w) && !punctuation.test(w));

        while (finalAnswers.length < 4 && remainingAnswers.length > 0) {
            const randomNumber = Math.floor(Math.random() * remainingAnswers.length);
            const answer = remainingAnswers.splice(randomNumber, 1)[0];
            finalAnswers.push(answer);
        }
        finalAnswers = finalAnswers.sort(() => Math.random() - 0.5);
        setAnswers(finalAnswers);

    };

    useEffect(() => {
        if (info.q_type !== "Kasus bestimmen" && !edit) {
            createAnswers(info?.sentence_array, info?.solution);
        }
    }, []);
    
    const changeNoun = (noun, kasus) => {

        setAnswers([]);

        setTimeout(() => {
            setChosenNoun({
                noun: noun,
                kasus: kasus
            });
            setAnswers(["Nominativ", "Akkusativ", "Dativ", "Genitiv"]);
        }, 200);

    };

    const onRes = (res, data) => {

        setLoading(false);

        if(!res) {
            setError("Server nicht erreichbar!");
        };

        if (edit) {
            navigate(-1);
        }

        if(res.status === 200) {
            onSuccess(data);
        } else {
            onFail();
        }

    };

    const addQuestion = () => {

        let finalInfo;
        const oldSentence = info.sentence;
        const newSentence = oldSentence.replace(/\<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
        if (info.q_type === "Kasus bestimmen") {
            if (chosenNoun.noun && chosenNoun.noun !== "") {
                const newQuestion = {
                    answer: chosenNoun.kasus,
                    options: answers,
                    question_text: `In welchem Kasus ist das Wort ${chosenNoun.noun}?`,
                    sentence: newSentence,
                    q_type: info.q_type
                }
                let allCopy = [...allQuestions];
                allCopy.push(newQuestion);

                finalInfo = {
                    id: info.id,
                    questions: allCopy
                }

            } else {
                setError("Bitte wähle eines der Nomen aus!");
                return;
            }
        } else {
            const alterQuestion= info.question.replace(/\([^)]*\)/g, " ").replace(/\s+/g, " ").trim();
            const newQuestion = {
                answer: info.solution,
                options: answers,
                question_text: alterQuestion,
                sentence: newSentence,
            }
            let allCopy = [...allQuestions];
            allCopy.push(newQuestion);

            finalInfo = {
                id: info.id,
                questions: allCopy
            }
        }

        setLoading(true);
        post("/add/quiz/question", finalInfo, onRes, onRes);

    };

    const handleDelete = () => {

        const url = location.pathname.split("/");
        const frage = url.findIndex(s => s === "frage");
        const frageID = frage >= 1 ? Number(url[frage + 1]) : null;

        let newQuestions = [...allQuestions];
        newQuestions.splice(frageID - 1, 1);

        const finalInfo = {
            id: info.id,
            questions: newQuestions
        };

        setLoading(true);
        post("/add/quiz/question", finalInfo, onRes, onRes);

    };

    const handleBack = () => {
        navigate(-1);
        buttonOne();
    };

    if (loading) {
        return (
            <div className="flex-row" style={{height: "calc(100vh - 160px)", width: "100vw"}}>
                <Loading />
            </div>
        );
    }

    if (edit) {
        return (
            <div>
                <h2>FRAGE BEARBEITEN</h2>

                <p>Satz: </p>

                <p>{info.sentence}</p>

                <p style={{marginTop: "20px"}}>Frage: </p>

                <p>{info.question_text}</p>

                <p style={{marginTop: "20px"}}>Antworten: </p>

                <div className="answer-grid">
                    {info?.options?.map((a, i) => {

                        return (
                            <div 
                            key={i}
                            style={{
                                background: info.answer.includes(a) ? 
                                "rgba(0, 150, 0, 0.8)" 
                                : "rgba(255, 0, 0, 0.8)"
                            }}
                            >
                                {a}
                            </div>
                        );
                    })}
                </div>

                <div className="flex-row row-start" style={{marginTop: "20px"}}>
                    <div onClick={handleBack}>
                        <Button className="button-yellow" text="Zurück" />
                    </div>

                    <div onClick={handleDelete}>
                        <Button className="button-blue" text="Löschen" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <h2>FRAGE BEARBEITEN</h2>
            
            <p>Super! Dein Satz wurde analysiert. Hier ist das Resultat und die dazügehörige Aufgabenstellung:</p>

            <p>Satz: </p>

            <div 
                dangerouslySetInnerHTML={{__html: info.sentence}}
            />

            <p style={{
                marginTop: "20px"
            }}>Frage/Aufgabe: </p>

            <p>{info.question}</p>

            {info.q_type === "Kasus bestimmen" &&
                <div>
                    {info?.solution?.length === 0 ? (
                        <p>Dieser Satz hat kein Nomen. Bitte versuche es erneut!</p>
                    ) : (
                        <div>
                            {info?.solution?.map((e, i) => {
                                return (
                                    <div 
                                    key={i} 
                                    className="flex-row" 
                                    style={{justifyContent: "flex-start", cursor: "pointer"}}
                                    onClick={() => changeNoun(e.noun, e.kasus)}
                                    >
                                        <p>Nomen: {e.noun}</p>
                                        <p>Kasus: {e.kasus}</p>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    <div className="flex-row" style={{justifyContent: "flex-start", marginTop: "10px"}}><p style={{color: "var(--yellow)"}}>Ausgewählt:</p> <p style={{color: "var(--yellow)"}}>{chosenNoun.noun}</p></div>
                </div>
            }

            {answers.length > 0 &&
                <>
                    <p style={{
                        marginTop: "20px"
                    }}>Antwortmöglichkeiten: </p>
                    
                    <div className="answer-grid">
                        {answers.map((a, i) => {

                            return (
                                <div 
                                key={i}
                                style={{
                                    background: info.solution.includes(a) || chosenNoun.kasus === a ? 
                                    "rgba(0, 150, 0, 0.8)" 
                                    : "rgba(255, 0, 0, 0.8)"
                                }}
                                >{a}</div>
                            );
                        })}
                    </div>
                </>
            }

            <div style={{marginTop: "30px"}} onClick={buttonOne}>
                    <Button className="button-blue" text="Bearbeiten" />
            </div>

            <div onClick={addQuestion}>
                <Button className="button-yellow" text="Bestätigen" />
            </div>

            {error &&
                <div className="start-warning">
                    <p>{error}</p>
                </div>
            }
        </div>
    );
}; export default EditQuiz;